import {
  CheckboxLabelButton,
  FilterCard,
  RadioButtonGroup,
  SelectInput
} from "../../../../component"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { useSubheader } from "../../../../_metronic/layout"
import { useHistory } from "react-router-dom"
import { useLocation } from "react-router"
import { useUrlParam } from "../../../hooks/useUrlParams"
import { useDispatch, useSelector } from "react-redux"
import { initialFilterTable } from "../../../../component/atoms/Tabel"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import { DateRange } from "react-date-range"
import { CalenderSvgIcon } from "../../../../component/atoms/Icons/SVG/calender"
import { clearDataDetail, getAllMitra } from "../../../../redux/actions/MitraAction"
import { getActivityLandKur } from "../../../../redux/actions/AreaAction"
import { getListFarmer } from "../../../../redux/actions/FarmerAction"
import {
  getActivityStatusEnumFilter,
  getActivityTypeList,
  getPlantType
} from "../../../../redux/actions/MasterDataAction"
import { dateSelect } from "../../../helpers/DateHelper"
import { format } from "date-fns"
import { TableActivityKur } from "./component/TableActivityKur"
import { useTranslation } from "react-i18next"

export function ListAreaActivityKur() {
  const [isFilterEmptyState, setIsFilterEmptyState] = useState(false)
  const [filterOn, setFilterOn] = useState(false)
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const [showFilter, setShowFilter] = useState(false)
  const [btnFilterDisable, setBtnFilterDisable] = useState(true)
  const [typeValue, setTypeValue] = useState([])
  const [typeValueStatus, setTypeValueStatus] = useState([])
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [dateRange, setDateRange] = useState("")
  const [openDate, setOpenDate] = useState(false)
  const [mitra, setMitra] = useState("")
  const [farmer, setFarmer] = useState("")
  const [isType, setIsType] = useState([])
  const [typeId, setTypeId] = useState("")
  const [stateMitra, setStateMitra] = useState()
  const [statePlantType, setStatePlantType] = useState([])
  const [stateFarmer, setStateFarmer] = useState([])
  const isReadOnly = false
  const [search, setSearch] = useState({
    string_filter: ""
  })
  const [initialValue, setInitialValue] = useState({
    mitra_id: "",
    activity_type: "",
    status: "",
    start_date: "",
    farmer_id: "",
    end_date: "",
    plant_type: ""
  })
  const [state, setState] = useState([
    {
      startDate: "",
      endDate: "",
      key: "selection"
    }
  ])
  const subheader = useSubheader()
  const formRef = useRef()
  const history = useHistory()
  const location = useLocation()
  const urlParams = useUrlParam()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { General, Area, Mitralist, MasterData, Farmer } = useSelector((state) => state)

  function fetchData(param) {
    dispatch(getActivityLandKur(param))
  }

  useEffect(() => {
    subheader.setTitle(t("sub_header_activity_report_kur"))
    subheader.setButton(null)
    dispatch(getListFarmer())
    dispatch(getPlantType())
    dispatch(getActivityStatusEnumFilter())
    dispatch(getActivityTypeList())
    dispatch(getAllMitra())
    return () => {
      dispatch(clearDataDetail())
    }
  }, [])

  useEffect(() => {
    if (MasterData.activityTypeList) {
      setIsType(
        MasterData.activityTypeList.map((item) => {
          return {
            enum: item.id,
            label: item.name,
            checked: typeValue.findIndex((e) => e === item.id) >= 0
          }
        })
      )
    }
  }, [MasterData.activityTypeList, typeValue])

  useEffect(() => {
    if (MasterData.plantType) {
      setStatePlantType(
        MasterData.plantType.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    }
  }, [MasterData.plantType])

  useEffect(() => {
    if (Farmer.list) {
      setStateFarmer(
        Farmer.list.map((value) => ({
          label: `${value.name}, ${value.code}`,
          value: value.id
        }))
      )
    }
  }, [Farmer.list])
  useEffect(() => {
    if (Mitralist.data) {
      setStateMitra(
        Mitralist.data.map((value) => ({
          label: `${value.name}, ${value.code}`,
          value: value.id_mitra
        }))
      )
    }
  }, [Mitralist.data])

  useEffect(() => {
    if (
      formRef.current.values?.mitra_id ||
      formRef.current.values?.farmer_id ||
      typeId.length > 0 ||
      typeValue.length > 0 ||
      typeValueStatus.length > 0 ||
      dateRange
    )
      setBtnFilterDisable(false)
    else setBtnFilterDisable(true)
  }, [formRef.current, mitra, typeValue, typeValueStatus, dateRange, typeId, farmer])

  useEffect(() => {
    const result = location?.search
    fetchData(result)
  }, [location.search])

  useEffect(() => {
    setQueryStringObj(urlParams.getUrlParamsObj)
  }, [urlParams.getUrlParamsObj])

  useEffect(() => {
    if (queryStringObj?.string_filter) {
      setSearch({ string_filter: queryStringObj?.string_filter })
      setIsActiveSearch(true)
    }
    if (
      queryStringObj?.mitra_id ||
      queryStringObj?.farmer_id ||
      queryStringObj?.activity_type ||
      queryStringObj?.status ||
      queryStringObj?.plant_type_id ||
      queryStringObj?.start_date ||
      queryStringObj?.end_date
    ) {
      const data = {
        ...initialFilterTable,
        mitra_id: queryStringObj?.mitra_id,
        farmer_id: queryStringObj?.farmer_id,
        activity_type: queryStringObj?.activity_type,
        status: queryStringObj?.status,
        start_date: queryStringObj?.start_date,
        end_date: queryStringObj?.end_date,
        plant_type_id: queryStringObj?.plant_type_id
      }
      if (data) {
        setFilterOn(true)
        setInitialValue(data)
        setTypeId(data?.plant_type_id ?? "")
        setMitra(data?.mitra_id ?? "")
        setFarmer(data?.farmer_id ?? "")
        if (data?.activity_type) {
          setTypeValue(data?.activity_type.split(","))
        }
        if (data?.status) {
          setTypeValueStatus(data?.status.split(","))
        }
        if (data?.end_date && data.start_date) {
          let selectedDate =
            dateSelect(format(new Date(data.start_date), "yyyy-MM-dd")) +
            " s/d " +
            dateSelect(format(new Date(data.end_date), "yyyy-MM-dd"))
          setDateRange(selectedDate)
          setState([
            {
              startDate: new Date(data?.start_date),
              endDate: new Date(data?.end_date),
              key: "selection"
            }
          ])
        } else {
          setDateRange("")
        }
      }
    }
  }, [queryStringObj])

  function searchFunc(values) {
    setSearch({ string_filter: values.string_filter })
    setIsActiveSearch(true)
    let param = {
      ...initialFilterTable,
      ...initialValue,
      string_filter: values.string_filter
    }
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  function onSubmitForm(e) {
    const valueArray = 0
    const { values, submited } = e
    setShowFilter(false)
    setFilterOn(true)
    if (submited) {
      let paramData = {
        ...initialFilterTable,
        mitra_id: values?.mitra_id,
        activity_type: typeValue,
        status: typeValueStatus,
        plant_type_id: typeId,
        farmer_id: values?.farmer_id,
        start_date: state[valueArray].startDate
          ? format(state[valueArray].startDate, "yyyy-MM-dd")
          : "",
        end_date: state[valueArray].endDate ? format(state[valueArray].endDate, "yyyy-MM-dd") : "",
        string_filter: search.string_filter
      }
      if (paramData) {
        setInitialValue(paramData)
        const urlParam = getUrlParsingPageFilter(paramData)
        history.push({ pathname: location.pathname, search: urlParam })
      }
    }
  }

  function onChangeMitra(e) {
    setMitra(e)
  }

  function onChangeFarmer(e) {
    setFarmer(e)
  }

  function filterOnReset() {
    setDateRange("")
    setShowFilter(false)
    setFilterOn(false)
    setFarmer("")
    setMitra("")
    setTypeId("")
    setTypeValue([])
    setTypeValueStatus([])
    setState({
      startDate: "",
      endDate: "",
      key: "selection"
    })
    setInitialValue({
      ...initialFilterTable,
      mitra_id: "",
      activity_type: "",
      status: "",
      start_date: "",
      end_date: "",
      plant_type: "",
      farmer_id: ""
    })
    setShowFilter(false)
    setFilterOn(false)

    setInitialValue({
      activity_type: "",
      status: "",
      mitra_id: "",
      farmer_id: "",
      plant_type_id: "",
      start_date: "",
      end_date: ""
    })
    resetDate()
    setTypeValue([])
    let param = {
      ...initialFilterTable,
      activity_type: "",
      status: "",
      mitra_id: "",
      farmer_id: "",
      plant_type_id: "",
      start_date: "",
      end_date: "",
      string_filter: search.string_filter
    }
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  function handleReset() {
    let param = {
      ...initialFilterTable,
      ...initialValue,
      string_filter: ""
    }
    const urlParam = getUrlParsingPageFilter(param)
    setSearch({ string_filter: "" })
    history.push({ pathname: location.pathname, search: urlParam })
  }

  function handleOpenCloseFilter(value) {
    setShowFilter(value)
  }

  const changePage = useCallback(
    (param) => {
      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...initialValue,
          ...param,
          sort: param?.sortField ? param.sortField + "," + param.sortOrder : "",
          string_filter: search.string_filter
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...initialValue,
          ...param,
          string_filter: search.string_filter
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [dispatch, search, initialValue]
  )

  useEffect(() => {
    if (filterOn) {
      setIsFilterEmptyState(true)
    } else if (isActiveSearch) {
      setIsFilterEmptyState(true)
    } else {
      setIsFilterEmptyState(false)
    }
  }, [isActiveSearch, filterOn, location])

  function handleType(data) {
    const { name, checked } = data.target
    if (checked) {
      setTypeValue([...typeValue, name])
    } else {
      let filteredStatus = typeValue.filter((item) => item !== name)
      setTypeValue(filteredStatus)
    }
  }

  function submitLog() {
    const valueArray = 0
    let selectedDate =
      dateSelect(format(state[valueArray].startDate, "yyyy-MM-dd")) +
      " s/d " +
      dateSelect(format(state[valueArray].endDate, "yyyy-MM-dd"))
    setDateRange(selectedDate)
    setOpenDate(false)
  }

  function resetDate() {
    setOpenDate(false)
    setDateRange("")
    setState([
      {
        startDate: "",
        endDate: "",
        key: "selection"
      }
    ])
  }

  function selectDate() {
    return (
      <div className={"d-flex justify-content-end"}>
        <div
          onClick={() => setOpenDate(!openDate)}
          className={
            "select-date d-flex justify-content-between align-items-center cursor-pointer"
          }>
          <label className={"mb-0 txt-12 cursor-pointer"}>
            {dateRange ? dateRange : t("label_select_date_range")}
          </label>
          <CalenderSvgIcon />
        </div>
      </div>
    )
  }

  function dateRangePicker() {
    return (
      <div style={{ transform: `translateY(23px)` }}>
        <div className={"date-picker-custom "} style={{ fontSize: 11 }}>
          <DateRange
            className={"font-10"}
            onChange={(item) => setState([item.selection])}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={1}
            ranges={state}
            direction="horizontal"
            preventSnapRefocus={true}
            calendarFocus="backwards"
          />
          <div className={"action-wrapper d-flex justify-content-end py-4 px-4 border-top"}>
            <button onClick={resetDate} type={"button"} className={"btn btn-outline-primary mx-4"}>
              {t("label_reset_date")}
            </button>
            <button onClick={submitLog} type={"button"} className={"btn btn-primary mx-4"}>
              {t("label_apply")}
            </button>
          </div>
        </div>
      </div>
    )
  }

  function filterComponent() {
    return (
      <>
        <Card className="card-custom card-shadowless ">
          <CardHeader title={t("label_farmer")} className="px-0 min-h-2" />
          <CardBody className="px-0 py-5">
            <RowModule>
              <SelectInput
                name="farmer_id"
                onChange={onChangeFarmer}
                editable={!isReadOnly}
                label={t("label_farmer_name")}
                placeholder={t("placeholder_choose_one")}
                options={stateFarmer}
                withoutFeedback={true}
                clearNow={true}
                value={farmer}
              />
            </RowModule>
          </CardBody>
        </Card>

        <Card className="card-custom card-shadowless">
          <CardHeader title={t("label_mitra")} className="px-0 min-h-2" />
          <CardBody className="px-0 py-5">
            <RowModule>
              <SelectInput
                name="mitra_id"
                onChange={onChangeMitra}
                editable={!isReadOnly}
                label={t("label_mitra_name")}
                placeholder={t("placeholder_choose_one")}
                options={stateMitra}
                withoutFeedback={true}
                clearNow={true}
                value={mitra}
              />
            </RowModule>
          </CardBody>
        </Card>
        <Card className="card-custom card-shadowless">
          <CardHeader title={t("label_plant_type")} className="px-0" />
          <CardBody className="px-0">
            {statePlantType.map((item) => (
              <RadioButtonGroup
                editable={false}
                key={item.value}
                onClick={() => {
                  setTypeId(item.value)
                }}
                checked={typeId == item.value}
                name="plant_type"
                label={item.label}
                value={item.value}
              />
            ))}
          </CardBody>
        </Card>
        <Card className="card-custom card-shadowless">
          <CardHeader title={t("label_activity_type")} className="px-0" />
          <CardBody className="px-0">
            <CheckboxLabelButton
              formInitialValues={typeValue}
              isStatus={isType}
              name={"activity_type"}
              innerRef={formRef}
              handleChange={handleType}
            />
          </CardBody>
        </Card>

        <Card className="card-custom card-shadowless">
          <CardHeader title={t("label_activity_date")} className="px-0 min-h-2" />
          <CardBody className="px-0 py-5">
            {selectDate()}
            {openDate && dateRangePicker()}
          </CardBody>
        </Card>
      </>
    )
  }

  return (
    <>
      <FilterCard
        // seacrh
        isActiveSearch={isActiveSearch}
        placeholder={t("placeholder_insert_area_name_or_farmer")}
        onSubmitForm={searchFunc}
        initialValues={search}
        name={"string_filter"}
        innerRef={formRef}
        trigerReset={handleReset}
        // filter
        filterInnerRef={formRef}
        filterHandleSubmit={onSubmitForm}
        filterFormInitialValues={initialValue}
        filterComponent={filterComponent()}
        filterOnReset={filterOnReset}
        showFilter={showFilter}
        handleOpenCloseFilter={handleOpenCloseFilter}
        filterOn={filterOn}
        btnDisable={btnFilterDisable}></FilterCard>

      <Card>
        <RowModule>
          <TableActivityKur
            history={history}
            general={General}
            data={Area}
            changePage={changePage}
            isFilter={isFilterEmptyState}
          />
        </RowModule>
      </Card>
    </>
  )
}